import React, { Component, } from 'react'
import _ from 'lodash'

import {CCCoinPile, Constants, CCIcon, colors, strings} from './../../cc-imports'
import './../../styles/css/components/CCEntryItem/cc-entry-item.css'
import CCErrorBoundary from "../CCErrorBoundary/CCErrorBoundary";

class CCEntryItem extends Component {
    static propTypes = {};
    static defaultProps = {
        first: false
    };

    constructor(props) {
        super(props);
        this.state = {};
        this._getMessage = this._getMessage.bind(this);
        this._getScoreRank = this._getScoreRank.bind(this);
        this._getEntryDetail = this._getEntryDetail.bind(this);
        this._getCategory = this._getCategory.bind(this);
        this._isCompleted = this._isCompleted.bind(this);
        this._getIconType = this._getIconType.bind(this);
    }

 
    _getCategory(category) {
        switch (category) {
            case 'DREAMTEAM':
                return strings('dream_team');
            case 'PREDICTION':
                return strings('target_prediction_entry');
            case 'LIVE_PREDICTION':
            case 'QUICK_PREDICTION':
                return strings('live_prediction_entry');
            default:
                return ''
        }
    }

    _getScoreRank(entry){
        if(entry.status==Constants.entryStatus.LIVE||entry.status==Constants.entryStatus.COMPLETED){
            var str = ''
            if (entry.league.category=='DREAMTEAM') {
                str=str+ strings('score')+entry.score+ strings('rank')+entry.rank;
            }
            else {
                str=str+ strings('rank')+entry.rank;
            }
            return (<h4 className={'cc-entry-item-rank'}>{str}</h4>)
        }
        else {
            return undefined;
        }
    }

    _getMessage(entry) {
        var message = entry.match.shortName + ' - ' + this._getCategory(entry.league.category);

        return message;
    }

    _getEntryDetail(entry){
        if(entry.league.category=='DREAMTEAM'){
            var dt = '';
            _.forEach(entry.dreamTeam, (player, index)=>{
                dt = dt + player.name + (index == entry.dreamTeam.length - 1 ? '' : ', ');
            });
            return (<h4 style={{fontSize : 11, color:colors.theme2.font_color2}}>{dt}</h4>)
        }
        else {
            return (<h4 style={{fontSize : 11, color:colors.theme2.font_color2}}>{entry.prediction}</h4>)
        }
    }

    _isCompleted(entry){
        return !(entry.status==Constants.entryStatus.LIVE||entry.status==Constants.entryStatus.NOT_STARTED)
    }

    _getIconType(league){
        switch (league.category){
            case Constants.leagueCategory.DREAMTEAM:
                return "dreamTeam"
                break;
            case Constants.leagueCategory.QUICK_PREDICTION:
            case Constants.leagueCategory.LIVE_PREDICTION:
                return 'livePrediction'
                break;
            case Constants.leagueCategory.PREDICTION:
                return 'targetPrediction'
                break;
            default:
                return ''
        }
    }

    render() {
       const {entry} = this.props;

        return (
            <CCErrorBoundary>
            <div className="flex-container cc-entry-parent">
                {
                    entry.winning &&
                    <div className={'flex-container cc-entry-winning'}>
                        <CCIcon className={'cc_league_icon_entry_win right'}  type={'winBanner'}/>
                        {
                            entry.rewarded &&
                            <CCIcon className={'cc_league_icon_entry'} type={'rewardBanner'}/>
                        }
                    </div>
                }


                <div className={'cc-entry-sub'} disabled={true}>
                    <div className="flex-container cc-entry-sub2">
                        <div className="flex-container cc-entry-sub3" >
                            <div className={'flex-container cc-entry-icon'}>
                                <div className={'flex-container cc-entry-icon-bg'}>
                                    <CCIcon className={"cc_league_icon_entry"} type={this._getIconType(entry.league)}/>
                                </div>
                            </div>


                            <div className="flex-container cc-entry-title" >
                                <h2 className={'cc-entry-title-c'}>{this._getCategory(entry.league.category)}</h2>
                                <h4 className={'cc-entry-title-sn'}>{entry.match.shortName}</h4>
                                {
                                    this._getScoreRank(entry)
                                }
                                {
                                    this._getEntryDetail(entry)
                                }
                            </div>
                            {
                                entry.winning &&
                                    <div className={'coin-pile-container'}>
                                        <CCCoinPile textClass={'entry-cp-font'} iconClass={'entry-cp-icon'} theme={'dark'} coins={entry.coinsEarned} />
                                    </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
            </CCErrorBoundary>
        )
    }
}

export default CCEntryItem


// WEBPACK FOOTER //
// ./src/app/components/CCEntryItem/CCEntryItem.js